import {
  removeElementById,
  removeElementsByClassName,
  removeJsOrCss,
} from '@phx-husky/browser-helpers';

import { SHOPPABLE_PLUGIN } from '~/utils/constants';

declare global {
  interface Window {
    PriceSpider: unknown;
  }
}

export const removePriceSpider = () => {
  if (window.PriceSpider) {
    removeJsOrCss('cdn.pricespider');
    removeJsOrCss('cdn.pricespider', false);
    removeElementsByClassName('ps-container');
    removeElementById('ps-lightbox-background');
    window.PriceSpider = null;
  }
};

export const handlePriceSpiderModalClose = () => {
  const priceSpiderModal = document.getElementsByClassName(
    'ps-container ps-lightbox ps-open'
  );
  if (priceSpiderModal) {
    document.documentElement.style.overflowY = '';
    document.body.style.overflowY = '';
  }
};

export const checkPriceSpiderAvailable = (
  shoppablePlugin?: string,
  priceSpider?: {
    key?: string;
    country?: string;
    url?: string;
  }
) =>
  (priceSpider &&
    SHOPPABLE_PLUGIN.PRICE_SPIDER === shoppablePlugin &&
    Boolean(priceSpider.key && priceSpider.country && priceSpider.url)) ||
  false;
